const Reviews = {
  setSwiperReviews: function () {
    const reviews = document.querySelectorAll('[data-reviews-carousel]');

    reviews.forEach(section => {
      const carousel = section.querySelector('.swiper');
      const pagination = section.querySelector('.swiper-pagination');
      const next = section.querySelector('.swiper-button-next');
      const prev = section.querySelector('.swiper-button-prev');

      new Swiper(carousel, {
        slidesPerView: 3,
        watchOverflow: true,
        preloadImages: false,
        speed: 1000,
        spaceBetween: 10,
        navigation: {
          nextEl: next,
          prevEl: prev,
          disabledClass: '-disabled'
        },
        pagination: {
          el: pagination,
          type: 'bullets',
          clickable: true,
        },
        breakpoints: {
          0: {
            slidesPerView: 1.15,
            spaceBetween: 10,
          },
          425: {
            slidesPerView: 1.35,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 24,
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 24,
          }
        }
      });
    });
  },

  handleModalReviews: function () {
    if (document.querySelector('[data-reviews-carousel]')) {
      document.querySelector('[data-btn-review]').addEventListener('click', openModal);

      document.querySelector('[data-close-review]').addEventListener('click', closeModal);
      // Função para abrir o modal
      function openModal() {
        document.getElementById('starContainer').innerHTML = '';

        for (let i = 1; i <= 5; i++) {
          const star = document.createElement('div');
          const svgIcon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
          const useElement = document.createElementNS('http://www.w3.org/2000/svg', 'use');

          star.className = 'star';
          svgIcon.classList.add('icon');
          useElement.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', '#icon-starmodal');

          svgIcon.appendChild(useElement);
          star.setAttribute('data-rating', i);
          star.appendChild(svgIcon);

          svgIcon.style.fill = 'transparent';
          document.getElementById('starContainer').appendChild(star);
        }

        const stars = document.querySelectorAll('.star');
        stars.forEach((star) => {
          star.addEventListener('click', () => {
            setRating(star);
          })
        })

        notSendName();

        document.getElementById("modal-review").style.display = "flex";
      }
    }

    function closeModal() {
      document.getElementById("modal-review").style.display = "none";
    }

    function setRating(star) {
      const selectedRating = star.dataset.rating;
      const stars = document.querySelectorAll('.star');
      stars.forEach(star => {
        const rating = star.getAttribute('data-rating');
        const svgIcon = star.querySelector('.icon use');

        if (rating <= selectedRating) {
          svgIcon.style.fill = '#f8a92d';
        } else {
          svgIcon.style.fill = '';
        }
      });

      // Atualiza o valor do input hidden com a avaliação selecionada
      document.getElementById('ratingInput').value = selectedRating;
    }
    function notSendName() {
      const checkboxNotName = document.getElementById('not-name');
      const inputName = document.getElementById('name');

      checkboxNotName.addEventListener('change', function () {
        if (checkboxNotName.checked) {
          inputName.setAttribute('disabled', 'disabled');
          inputName.value = '';
          inputName.removeAttribute('required');
          inputName.classList.add('disabled');

        } else {
          inputName.removeAttribute('disabled');
          inputName.setAttribute('required', 'required');
          inputName.classList.remove('disabled');
        }
      });
    }
  },
  init: function () {
    const _this = this;
    _this.setSwiperReviews();
    _this.handleModalReviews();
  }
}

export default Reviews;
